import { useEffect, useState } from "react";
import {
    PayPalScriptProvider,
    PayPalButtons,
    usePayPalScriptReducer
} from "@paypal/react-paypal-js";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PaymentApi, SubscribeApi } from "../../Redux/Auth/Auth_Action";
import { toast } from "react-toastify";

// This values are the props in the UI
const amount = "2";
const currency = "USD";
const style = { "layout": "vertical" };
const ButtonWrapper = ({ currency, showSpinner, props }) => {
    const navigate = useNavigate();
    const [state, setState] = useState(null);
    const dipatchItem = useDispatch();
    console.log(props, ' from button wrapper component');
    // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
    // This is the main reason to wrap the PayPalButtons in a new component
    const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
    const reduxStateToken = useSelector((state) => state.Auth.token);

    useEffect(() => {
        dispatch({
            type: "resetOptions",
            value: {
                ...options,
                currency: currency,
            },
        });
    }, [currency, showSpinner]);

    const SubscribeFunc = (NewData, reduxStateToken, type) => {
        dipatchItem(SubscribeApi(NewData, reduxStateToken, type))
            .then((res) => {
                console.log(res?.data?.message);
                toast.success(`${res?.data?.message}`);
                navigate("/Thankyou");
                // console.log("res", res);
            }).catch((e) => {
                console.log("errror from checkout page ", e);
            })
    }

    const SubmitData = (data) => {
        if (state) {
            if (props?.subscriptionId) {
                let NewData = {
                    price: props?.price,
                    slug: props?.slug,
                    interest: props?.interestsData,
                    payment_type: "venmo",
                    payment_id: state,
                    subscription_id: props?.subscriptionId,
                }
                let type = "venmo-renew";
                SubscribeFunc(NewData, reduxStateToken, type)
            } else {
                let type = "normal-subscription";
                let NewData = {
                    price: props?.price,
                    slug: props?.slug,
                    interest: props?.interestsData,
                    payment_type: "venmo",
                    payment_id: state,
                }
                SubscribeFunc(NewData, reduxStateToken)
            }
        }
    }

    useEffect(() => {
        SubmitData();
    }, [state])

    // console.log(state, 'xxxxxxxxxxxxxxxxxxxxxxxxx');

    return (<>
        {(showSpinner && isPending) && <div className="spinner" />}
        <PayPalButtons
            style={style}
            disabled={!props?.interestsData?.[0]}
            forceReRender={[props?.price, currency, style]}
            fundingSource="venmo"
            createOrder={(data, actions) => {
                return actions.order
                    .create({
                        purchase_units: [
                            {
                                amount: {
                                    currency_code: currency,
                                    value: props?.price,
                                },
                            },
                        ],
                    })
                    .then((orderId) => {
                        return orderId;
                    });
            }}
            onApprove={function (data, actions) {
                return actions.order.capture().then(function (details) {
                    setState(details?.purchase_units?.[0]?.payments?.captures?.[0]?.id);
                });
            }}
        />
    </>
    );
}

export default ButtonWrapper;